import { render } from "./ResourcesCreateOffline.vue?vue&type=template&id=78b9d335"
import script from "./ResourcesCreateOffline.vue?vue&type=script&lang=js"
export * from "./ResourcesCreateOffline.vue?vue&type=script&lang=js"

import "./ResourcesCreateOffline.vue?vue&type=style&index=0&id=78b9d335&lang=css"
/* custom blocks */
import block0 from "./ResourcesCreateOffline.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__